import _toConsumableArray from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import _ from 'lodash';
import computeWithPriceCartV2 from '../graphql/calculations/mutations/compute-with-price-cart.gql';
import { CALCULATION_PRICE_SERVICE } from '../constants';
import { Receipt } from './receipt';
import { mapInputsForPriceCartAPI, updateReceiptFromPriceCartAPI } from './utilities';
import { taxes } from './taxes';
var handlePriceCartRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apolloClient, restApi, priceCartInput, priceService, input, body, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apolloClient = _ref.apolloClient, restApi = _ref.restApi, priceCartInput = _ref.priceCartInput, priceService = _ref.priceService;
            if (!apolloClient) {
              _context.next = 4;
              break;
            }
            // we only want to add this on cart requests, not server-orders or D+
            input = Object.assign(priceCartInput, {
              includeGamification: true
            });
            return _context.abrupt("return", apolloClient.mutate({
              mutation: computeWithPriceCartV2,
              variables: {
                priceCartInput: input
              }
            }));
          case 4:
            body = {
              input: priceCartInput
            };
            url = priceService === CALCULATION_PRICE_SERVICE.plus ? "/plus_enterprise/checkouts/price_cart_v2" : "/rest/carts/price_cart_v2";
            return _context.abrupt("return", restApi.post(url, body));
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function handlePriceCartRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export function priceCartComputer(_x2, _x3, _x4, _x5, _x6) {
  return _priceCartComputer.apply(this, arguments);
}

// POS-13717: Extract unique applied discounts with their restriction metadata
function _priceCartComputer() {
  _priceCartComputer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, logger, apolloClient, restApi, priceService) {
    var _response$data$comput, _response$data, _response$data2, _receipt$summary, _appliedRewards$, _priceCartOutput$disc, _priceCartOutput$disc2;
    var appliedRewards, cart, cartAddress, consolidateReceiptDiscountsEnabled, couponObject, couponActions, deliveryOption, deliveryScheduleType, dispensary, loyaltyPointsApplied, medicalOrder, paymentMethod, payerId, posCustomerId, rewardActions, tipValue, toMenu, userId, preOrderType, platformType, _ref3$roundupForChari, roundupForCharityEnabled, _taxes, details, salesTaxExistence, cannabisTaxExistence, bottleDepositTaxExistence, receipt, priceCartInput, response, hasTimeoutError, logMessage, priceCartOutput, mixAndMatchEnabled, pricingTierTotalPerOrder, feeTotals, discountIncentives, rewardDiscount, couponOutput, credit, roundupForCharityAmount, _updateReceiptFromPri, cartProductKeys, coupon, tip, _tipValue$0$dollar, _tipValue$, _tipValue$dollar, roundupForCharityAmountInDollars, total;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            appliedRewards = _ref3.appliedRewards, cart = _ref3.cart, cartAddress = _ref3.cartAddress, consolidateReceiptDiscountsEnabled = _ref3.consolidateReceiptDiscountsEnabled, couponObject = _ref3.coupon, couponActions = _ref3.couponActions, deliveryOption = _ref3.deliveryOption, deliveryScheduleType = _ref3.deliveryScheduleType, dispensary = _ref3.dispensary, loyaltyPointsApplied = _ref3.loyaltyPointsApplied, medicalOrder = _ref3.medicalOrder, paymentMethod = _ref3.paymentMethod, payerId = _ref3.payerId, posCustomerId = _ref3.posCustomerId, rewardActions = _ref3.rewardActions, tipValue = _ref3.tipValue, toMenu = _ref3.toMenu, userId = _ref3.userId, preOrderType = _ref3.preOrderType, platformType = _ref3.platformType, _ref3$roundupForChari = _ref3.roundupForCharityEnabled, roundupForCharityEnabled = _ref3$roundupForChari === void 0 ? false : _ref3$roundupForChari;
            if (!(!dispensary || !cart)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", {});
          case 3:
            _taxes = taxes(cart, dispensary, medicalOrder, deliveryOption === 'delivery', toMenu), details = _taxes.details, salesTaxExistence = _taxes.salesTaxExistence, cannabisTaxExistence = _taxes.cannabisTaxExistence, bottleDepositTaxExistence = _taxes.bottleDepositTaxExistence;
            receipt = new Receipt(dispensary);
            priceCartInput = {};
            _context2.prev = 6;
            priceCartInput = mapInputsForPriceCartAPI({
              cart: cart,
              address: cartAddress,
              deliveryOption: deliveryOption,
              medicalOrder: medicalOrder,
              userId: userId,
              dispensaryId: dispensary.id,
              paymentMethod: paymentMethod,
              couponCode: couponObject === null || couponObject === void 0 ? void 0 : couponObject.code,
              appliedRewards: appliedRewards,
              loyaltyPointsApplied: loyaltyPointsApplied,
              deliveryScheduleType: deliveryScheduleType,
              payerId: payerId,
              posCustomerId: posCustomerId,
              preOrderType: preOrderType,
              platformType: platformType
            });
            _context2.next = 14;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](6);
            logger.error('Invalid product data in cart', {
              priceService: priceService,
              dispensaryId: dispensary.id,
              cart: cart
            });
            throw _context2.t0;
          case 14:
            if (!_.isEmpty(priceCartInput.cart)) {
              _context2.next = 17;
              break;
            }
            receipt.finalize();
            return _context2.abrupt("return", emptyCartResponse(receipt));
          case 17:
            _context2.prev = 17;
            _context2.next = 20;
            return handlePriceCartRequest({
              apolloClient: apolloClient,
              restApi: restApi,
              priceCartInput: priceCartInput,
              priceService: priceService
            });
          case 20:
            response = _context2.sent;
            _context2.next = 30;
            break;
          case 23:
            _context2.prev = 23;
            _context2.t1 = _context2["catch"](17);
            hasTimeoutError = extractTimeoutError(_context2.t1);
            logMessage = hasTimeoutError ? 'Price cart calculation timed out' : 'Price cart calculation failed - will fallback to legacy';
            logger.error(logMessage, {
              dispensaryId: dispensary.id,
              priceService: priceService,
              error: _context2.t1.message
            });
            receipt.finalize();
            return _context2.abrupt("return", _objectSpread(_objectSpread({}, emptyCartResponse(receipt)), {}, {
              shouldFallback: true,
              timedOut: hasTimeoutError,
              priceCartError: _context2.t1.message
            }));
          case 30:
            priceCartOutput = (_response$data$comput = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.computeWithPriceCartV2) !== null && _response$data$comput !== void 0 ? _response$data$comput : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.attributes;
            mixAndMatchEnabled = getMixAndMatchValue(dispensary.storeSettings, deliveryOption === 'delivery');
            _context2.prev = 32;
            _updateReceiptFromPri = updateReceiptFromPriceCartAPI({
              priceCartOutput: priceCartOutput,
              receipt: receipt,
              cartItems: cart,
              tipValue: tipValue,
              logger: logger,
              details: details,
              mixAndMatchEnabled: mixAndMatchEnabled,
              consolidateReceiptDiscountsEnabled: consolidateReceiptDiscountsEnabled,
              roundupForCharityEnabled: roundupForCharityEnabled
            });
            pricingTierTotalPerOrder = _updateReceiptFromPri.pricingTierTotalPerOrder;
            feeTotals = _updateReceiptFromPri.feeTotals;
            discountIncentives = _updateReceiptFromPri.discountIncentives;
            rewardDiscount = _updateReceiptFromPri.rewardDiscount;
            couponOutput = _updateReceiptFromPri.couponOutput;
            credit = _updateReceiptFromPri.credit;
            roundupForCharityAmount = _updateReceiptFromPri.roundupForCharityAmount;
            _context2.next = 48;
            break;
          case 43:
            _context2.prev = 43;
            _context2.t2 = _context2["catch"](32);
            cartProductKeys = cart ? Object.values(cart).map(function (item) {
              return item.key ? "".concat(item.key, "_").concat(item.quantity || 0) : null;
            }).filter(Boolean) : [];
            logger.error('Failed to update receipt from price cart API', {
              dispensaryId: dispensary.id,
              priceService: priceService,
              error: _context2.t2.message,
              cartItemPricesExists: !!(priceCartOutput !== null && priceCartOutput !== void 0 && priceCartOutput.cartItemPrices),
              cartProductKeys: cartProductKeys,
              priceCartOutput: priceCartOutput || {}
            });
            throw _context2.t2;
          case 48:
            coupon = handleDiscountByCode({
              couponOutput: couponOutput,
              couponActions: couponActions,
              dispensaryId: dispensary.id,
              priceService: priceService,
              couponObject: couponObject
            });
            handleRewardValidation({
              rewardErrors: priceCartOutput === null || priceCartOutput === void 0 ? void 0 : priceCartOutput.rewardValidationErrors,
              rewardActions: rewardActions
            });
            receipt.finalize();

            // discount: total credit/discount
            // grandTotal:6400 - total with rounding
            // originalTotal:6480 - total without rounding
            // roundedDifference:80 - rounding difference to nearest dollar
            // subTotal:5400 - total before taxes
            // taxes:1080

            // when on checkout tipValue looks like tipValue: {dollar: float},
            // but for the serverOrder tipValue is tipValue: [{dollar: float}]

            if (_.isArray(tipValue) && tipValue.length > 0) {
              tip = (_tipValue$0$dollar = (_tipValue$ = tipValue[0]) === null || _tipValue$ === void 0 ? void 0 : _tipValue$.dollar) !== null && _tipValue$0$dollar !== void 0 ? _tipValue$0$dollar : 0;
            } else {
              tip = (_tipValue$dollar = tipValue === null || tipValue === void 0 ? void 0 : tipValue.dollar) !== null && _tipValue$dollar !== void 0 ? _tipValue$dollar : 0;
            }
            roundupForCharityAmountInDollars = centsToDollars(roundupForCharityAmount);
            total = tip + centsToDollars(priceCartOutput.originalTotal) + roundupForCharityAmountInDollars;
            return _context2.abrupt("return", _objectSpread(_objectSpread({
              menuTotal: calculateMenuTotal(receipt.details.products, (_receipt$summary = receipt.summary) === null || _receipt$summary === void 0 ? void 0 : _receipt$summary.discounts),
              cartSubtotal: centsToDollars(priceCartOutput.subTotal),
              subtotal: centsToDollars(priceCartOutput.subTotal),
              bottleDepositTaxCents: Number(priceCartOutput.totalBottleDepositTax),
              cannabisTax: centsToDollars(priceCartOutput.totalCannabisTax),
              tax: centsToDollars(priceCartOutput.totalSalesTax),
              deliveryFee: centsToDollars(feeTotals.delivery),
              credit: centsToDollars(credit),
              mixAndMatch: centsToDollars(pricingTierTotalPerOrder),
              reward: Number(rewardDiscount),
              tip: tip,
              otherFees: centsToDollars(feeTotals.other),
              paymentFee: Number(feeTotals.payment),
              paymentIncentives: discountIncentives,
              // TODO: ensure incentives work as expected (id, name, value)
              roundupForCharityAmount: roundupForCharityAmountInDollars,
              total: total,
              details: details,
              lineitems: [{
                type: "productSubtotal",
                value: centsToDollars(priceCartOutput.subTotal)
              }, {
                type: "mixAndMatch",
                value: centsToDollars(pricingTierTotalPerOrder)
              }, {
                type: "discount",
                value: centsToDollars(credit)
              }, {
                type: "reward",
                value: Number(rewardDiscount),
                brand: !_.isEmpty(appliedRewards) ? (_appliedRewards$ = appliedRewards[0]) === null || _appliedRewards$ === void 0 ? void 0 : _appliedRewards$.brand : "Reward"
              }, {
                type: 'paymentFee',
                value: centsToDollars(feeTotals.payment)
              }, {
                type: 'deliveryFee',
                value: centsToDollars(feeTotals.delivery)
              }, {
                type: 'otherFees',
                value: centsToDollars(feeTotals.other)
              }, {
                type: 'tip',
                value: tip
              }, {
                type: 'bottleDepositTaxCents',
                value: Number(priceCartOutput.totalBottleDepositTax)
              }, {
                type: 'cannabisTax',
                value: centsToDollars(priceCartOutput.totalCannabisTax)
              }, {
                type: 'salesTax',
                value: centsToDollars(priceCartOutput.totalSalesTax)
              }, {
                type: 'roundupForCharity',
                value: roundupForCharityAmountInDollars
              }, {
                type: 'total',
                value: total
              }],
              salesTaxExistence: salesTaxExistence,
              // TODO: This would be driven by salesTax data from POS, via menu price
              cannabisTaxExistence: cannabisTaxExistence,
              // TODO: This would be driven by cannabisTax data from POS, via menu price
              bottleDepositTaxExistence: bottleDepositTaxExistence,
              // TODO: this would be driven by bottleTax data from POS, via menu price
              receipt: receipt.toJSON()
            }, priceService === CALCULATION_PRICE_SERVICE.checkout && coupon ? {
              coupon: coupon
            } : {}), {}, {
              timedOut: false,
              loyaltyAppliedAsDiscount: priceCartOutput.loyaltyAppliedAsDiscount / 100,
              calculationErrors: getCalculationErrors(priceCartOutput.rewardValidationErrors),
              gamificationDetails: serializeGamificationDetails((_priceCartOutput$disc = (_priceCartOutput$disc2 = priceCartOutput.discountGamification) === null || _priceCartOutput$disc2 === void 0 ? void 0 : _priceCartOutput$disc2.gamificationDetails) !== null && _priceCartOutput$disc !== void 0 ? _priceCartOutput$disc : [], cart, extractSpecialsFromCart(cart)),
              // POS-13717: Include applied discounts with restriction metadata for online membership discounts
              appliedDiscountsWithMetadata: extractAppliedDiscounts(priceCartOutput.cartItemPrices)
            }));
          case 55:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 10], [17, 23], [32, 43]]);
  }));
  return _priceCartComputer.apply(this, arguments);
}
var extractAppliedDiscounts = function extractAppliedDiscounts() {
  var cartItemPrices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allDiscounts = _.flatMap(cartItemPrices, function (item) {
    return (item === null || item === void 0 ? void 0 : item.discounts) || [];
  });
  // Deduplicate by discountId, keeping the full metadata
  var uniqueDiscounts = _.uniqBy(allDiscounts, 'discountId');
  return _.map(uniqueDiscounts, function (discount) {
    var _discount$isRestricte, _discount$menuDisplay, _discount$menuDisplay2, _discount$menuDisplay3;
    return {
      _id: String(discount.discountId),
      discountId: discount.discountId,
      name: discount.name,
      amount: discount.amount,
      applicationMethod: discount.applicationMethod,
      isLoyaltyReward: discount.isLoyaltyReward,
      isPaymentIncentive: discount.isPaymentIncentive,
      // Restriction metadata for online membership discounts
      isRestricted: (_discount$isRestricte = discount.isRestricted) !== null && _discount$isRestricte !== void 0 ? _discount$isRestricte : false,
      menuDisplayName: (_discount$menuDisplay = discount.menuDisplayName) !== null && _discount$menuDisplay !== void 0 ? _discount$menuDisplay : null,
      menuDisplayDescription: (_discount$menuDisplay2 = discount.menuDisplayDescription) !== null && _discount$menuDisplay2 !== void 0 ? _discount$menuDisplay2 : null,
      menuDisplayImage: (_discount$menuDisplay3 = discount.menuDisplayImage) !== null && _discount$menuDisplay3 !== void 0 ? _discount$menuDisplay3 : null
    };
  });
};
function centsToDollars(value) {
  return Number(Big(value).div(100));
}
function getCalculationErrors() {
  var rewardValidationErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _.map(rewardValidationErrors, function (error) {
    var message = errorMapper[error === null || error === void 0 ? void 0 : error.message];
    return message !== null && message !== void 0 ? message : error === null || error === void 0 ? void 0 : error.message;
  });
}
var errorMapper = {
  'Discount does not apply to any items in cart.': 'Cart is not eligible for this discount'
};
function handleDiscountByCode(_ref4) {
  var couponOutput = _ref4.couponOutput,
    couponActions = _ref4.couponActions,
    dispensaryId = _ref4.dispensaryId,
    priceService = _ref4.priceService,
    couponObject = _ref4.couponObject;
  if (couponOutput) {
    var couponReturnValue = _objectSpread(_objectSpread({}, couponOutput), {}, {
      dollar: Number(couponOutput.amount),
      code: couponObject.code,
      dispensaryId: dispensaryId,
      active: true,
      oneUsePerCustomer: false,
      addedDate: new Date(),
      _id: String(couponOutput.discountId)
    });
    if (priceService === CALCULATION_PRICE_SERVICE.cart) {
      couponActions.applyCouponCode(couponReturnValue);
      return null;
    }
    return couponReturnValue;
  }
  if (priceService === CALCULATION_PRICE_SERVICE.cart && couponObject) {
    couponActions.removeCoupon();
  }
  return null;
}
function handleRewardValidation(_ref5) {
  var rewardErrors = _ref5.rewardErrors,
    rewardActions = _ref5.rewardActions;
  if (rewardErrors && rewardErrors.length > 0) {
    rewardErrors.forEach(function (error) {
      if (error.discountId) {
        rewardActions.removeReward(error.discountId);
      }
    });
  }
}

// default response for D+ checkout that have no items, we don't want to make an API call so we return the costBreakdown
// with 0 for all values and an empty details array
var emptyCartResponse = function emptyCartResponse(receipt) {
  return {
    menuTotal: 0,
    cartSubtotal: 0,
    subtotal: 0,
    bottleDepositTaxCents: 0,
    cannabisTax: 0,
    tax: 0,
    deliveryFee: 0,
    credit: 0,
    mixAndMatch: 0,
    reward: 0,
    tip: 0,
    otherFees: 0,
    paymentFee: 0,
    paymentIncentives: [],
    total: 0,
    details: [],
    lineitems: [{
      type: 'productSubtotal',
      value: 0
    }, {
      type: 'mixAndMatch',
      value: 0
    }, {
      type: 'discount',
      value: 0
    }, {
      type: 'reward',
      value: 0,
      brand: 'Reward'
    }, {
      type: 'paymentFee',
      value: 0
    }, {
      type: 'deliveryFee',
      value: 0
    }, {
      type: 'otherFees',
      value: 0
    }, {
      type: 'tip',
      value: 0
    }, {
      type: 'bottleDepositTaxCents',
      value: 0
    }, {
      type: 'cannabisTax',
      value: 0
    }, {
      type: 'salesTax',
      value: 0
    }, {
      type: 'total',
      value: 0
    }],
    salesTaxExistence: {},
    cannabisTaxExistence: {},
    bottleDepositTaxExistence: {},
    receipt: receipt.toJSON(),
    coupon: null,
    // POS-13717: Empty array for applied discounts with metadata
    appliedDiscountsWithMetadata: []
  };
};
var extractTimeoutError = function extractTimeoutError(error) {
  return error.message && error.message.includes('Service Unavailable') || _.some(error.graphQLErrors, ['message', 'Service Unavailable']);
};
var calculateMenuTotal = function calculateMenuTotal(details) {
  var discount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var total = Big(0);
  _.forEach(details, function (detail) {
    total = total.plus(detail.menuPrice);
  });
  return centsToDollars(total.minus(discount));
};
var getMixAndMatchValue = function getMixAndMatchValue(settings, isDelivery) {
  if (isDelivery) {
    return settings === null || settings === void 0 ? void 0 : settings.enableMixAndMatchPricingForDelivery;
  }
  return settings === null || settings === void 0 ? void 0 : settings.enableMixAndMatchPricingForPickup;
};
var extractSpecialsFromCart = function extractSpecialsFromCart(cartItems) {
  var allSpecials = _.flatMap(cartItems, function (item) {
    var _item$product$special, _item$product$special2;
    return [].concat(_toConsumableArray(((_item$product$special = item.product.specialData) === null || _item$product$special === void 0 ? void 0 : _item$product$special.saleSpecials) || []), _toConsumableArray(((_item$product$special2 = item.product.specialData) === null || _item$product$special2 === void 0 ? void 0 : _item$product$special2.bogoSpecials) || []));
  });
  return _.uniqBy(allSpecials, 'specialId');
};
var serializeGamificationDetails = function serializeGamificationDetails(gamificationDetails) {
  var cartItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cartSpecials = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!gamificationDetails || _.isEmpty(gamificationDetails)) {
    return [];
  }
  var specialsIndex = _.keyBy(cartSpecials, 'sourceId');
  return _.chain(gamificationDetails).map(function (discount) {
    var equivalentCartSpecial = specialsIndex[discount.discountId.toString()];
    if (!equivalentCartSpecial) {
      return null;
    }
    var thresholds = _.map(discount.satisfiers, function (satisfier) {
      var applicableProducts = [];
      var currentAmount = _.reduce(satisfier.products, function (sum, product) {
        if (product.ecommKey && cartItems[product.ecommKey]) {
          applicableProducts.push({
            productKey: product.ecommKey,
            amount: product.amount
          });
          return sum + product.amount;
        }
        return sum;
      }, 0);
      return {
        // One of: GAMIFICATION_THRESHOLD_TYPES.NUMBER_OF_ITEMS | PRODUCT_GRAMS | SPENDING_AMOUNT
        thresholdType: satisfier.thresholdType,
        threshold: satisfier.minimumThreshold,
        thresholdMet: satisfier.thresholdMet,
        currentAmount: currentAmount,
        applicableProducts: applicableProducts
      };
    });
    return {
      specialId: equivalentCartSpecial.specialId,
      specialName: equivalentCartSpecial.specialName,
      allThresholdsMet: discount.meetsAllConstraints,
      thresholds: thresholds
    };
  }).compact().value(); // Remove null entries
};

// Export helper functions for testing
export { extractAppliedDiscounts, extractSpecialsFromCart, serializeGamificationDetails };